// assets/nd-export.js — PDF v4.3L + QuotationNo sync (GAS preferred, fallback DRAFT)
// RIGHT 區塊貼圖：與「Door Size」齊平；Unit/Line 置中＆欄寬微調；
// 取圖用「目標 pt→像素」(含 Overscale)；Transom + 三扇(DXX-XXX/DGP-SLS) + 四扇(DXX-XXXX/DGP-SPLS) 皆可額外加寬/加高；
// ★ 每個 line 的可用高度上/下界，放不下時自動換到下一頁；
// ★ Quotation # 與檔名：優先使用 GAS 回傳的正式編號（ND_QUOTE_SERIAL_FULL / ND_LAST_FINAL_QUOTE），
//   若尚未產生正式編號，仍允許匯出，改用 DRAFT-日期 樣式。
// ★ v4.3L-FactorPerUnit: Line/Total 改成「單價*factor→round(cents)→*qty→加總」（per-unit rounding）
// ★ PATCH: Hide internal props (uuid/_bss/_nd/nd:) from PDF export (DOM/options/properties)
(function () {
  if (window.__ND_EXPORT_V43L_FLOW_BOUND_NEXT_PAGE__) return;
  window.__ND_EXPORT_V43L_FLOW_BOUND_NEXT_PAGE__ = true;

  /* ------------ CLOUD CONFIG ------------ */
  const CLOUD_UPLOAD_ENABLED = true;
  const CLOUD_ENDPOINT = 'https://nd-onedrive-uploader-2.vercel.app/apps/nd-upload/upload';
  const ROOT_FOLDER = 'QuoteNeuma';

  /* ------------ IMAGE LAYOUT（可調） ------------ */
  const IMG_SCALE = 0.9;                     // 全局放大倍率
  const BASE_LAND_W = 45, BASE_LAND_H = 38;  // 橫圖基準尺寸（pt）
  const BASE_PORT_W = 32, BASE_PORT_H = 64;  // 直圖基準尺寸（pt）

  const RCOL_PAD = 8;                        // 右欄內距
  const RCOL_GAP_Y = 6;                      // 兩張圖的垂直間距
  const MAX_IMAGES_PER_ITEM = 2;             // 每品項最多幾張
  const RCOL_TOP_GUARD = 26;                 // 與主列金額的最小距離
  const ANCHOR_EXTRA_Y = 6;                  // 對齊 Door Size 後再往下推
  const RCOL_SHRINK_W = 4;                   // 右欄可用寬再縮一點，避免貼右邊

  // Transom (DGT-) bonus（pt）
  const TRANSOM_W_BONUS = 22;
  const TRANSOM_H_BONUS = -15;
  const TRANSOM_EXTRA_DOWN = 6;

  // 三扇/四扇 bonus（pt）
  const P3_W_BONUS = 20, P3_H_BONUS = 25;    // DXX-XXX、DGP-SLS
  const P4_W_BONUS = 26, P4_H_BONUS = 20;    // DXX-XXXX、DGP-SPLS

  // 提高清晰度：重取圖時多抓像素（再縮回來畫）
  const FETCH_OVERSCALE = 1.6;               // 1.0~2.0 越大越清晰（檔案也較大）

  // 圖片順序：'swap2' | 'reverse' | 'keep'
  const IMG_ORDER = 'swap2';
  function reorderImages(arr) {
    const a = Array.isArray(arr) ? arr.slice() : [];
    if (IMG_ORDER === 'swap2' && a.length >= 2) {
      const t = a[0]; a[0] = a[1]; a[1] = t;
    } else if (IMG_ORDER === 'reverse') {
      a.reverse();
    }
    return a;
  }

  // 名稱偵測
  const isTransomUrl = (u) => (/(?:^|\/)DGT-[A-Za-z0-9_-]+/i).test(String(u || ''));
  const isThreePanel = (u) =>
    (/(?:^|\/)D[A-Za-z0-9]{2}-[A-Za-z0-9]{3}(?=[._-]|$)/i).test(String(u || '')) ||
    (/(?:^|\/)DGP-SLS(?=[._-]|$)/i).test(String(u || ''));
  const isFourPanel = (u) =>
    (/(?:^|\/)D[A-Za-z0-9]{2}-[A-Za-z0-9]{4}(?=[._-]|$)/i).test(String(u || '')) ||
    (/(?:^|\/)DGP-SPLS(?=[._-]|$)/i).test(String(u || ''));

  // 1pt ≈ 1.333px（以 96DPI 算）
  const ptToPx = (pt) => Math.max(64, Math.round(pt * 1.3333));

  /* ------------ utils ------------ */
  const norm = s => String(s || '').toLowerCase().replace(/\s+/g, ' ').trim();
  const pad2 = n => String(n).padStart(2, '0');
  const fmtMDY = (d = new Date()) => `${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}-${d.getFullYear()}`;

  // ★ disclaimer：Config vs quotation
  const DISCLAIMER_TEXT =
    'Please Note : If there is any discrepancy between the configurator price and Neuma Doors Price Guide, Neuma Doors inside sales department will inform you and provide the price based on the price guide.';

  // ★ 會計式金額格式（3 位一逗點，保留兩位小數）
  function fmtMoney(val) {
    const num = Number(val || 0);
    const fixed = num.toFixed(2);
    const parts = fixed.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
  }
  // cents → "$x,xxx.xx"
  const money2 = c => fmtMoney(Number(c || 0) / 100);

  function j(id, fallback) {
    try {
      const el = document.getElementById(id);
      return el ? (JSON.parse(el.textContent || el.innerText || 'null') ?? fallback) : fallback;
    } catch (_) { return fallback; }
  }

  const CUST = j('cx2-customer-json', { id: null, email: null, tags: [] });
  const TAGS = j('cx2-tags-json', []);
  const customerEmail = (CUST?.email || 'guest').toLowerCase();

  // ★ 優先用 GAS 回傳的正式 quotation_no：
  //   1) ND_QUOTE_SERIAL_FULL（nd-quote-final.js 存的）
  //   2) ND_LAST_FINAL_QUOTE.quotation_no
  //   3) 舊版 ND_QUOTE_FINAL_INFO.quotation_no
  function getOfficialQuoteNo() {
    try {
      if (window.ND_QUOTE_SERIAL_FULL) {
        const q1 = String(window.ND_QUOTE_SERIAL_FULL).trim().toUpperCase();
        if (/^[A-Z0-9]{6}-\d{5}$/.test(q1)) return q1;
      }
      const info = window.ND_LAST_FINAL_QUOTE || window.ND_QUOTE_FINAL_INFO || null;
      if (!info || !info.quotation_no) return null;
      const q = String(info.quotation_no).trim().toUpperCase();
      if (!/^[A-Z0-9]{6}-\d{5}$/.test(q)) return null;
      return q;
    } catch (e) {
      return null;
    }
  }

  // 以下 localStorage 跑號工具，保留但不再用來命名檔案（只當備援資訊）
  function prefixFromTags() {
    const hit = Array.isArray(TAGS) ? TAGS.find(t => /^[A-Za-z0-9]{6}$/.test(String(t).trim())) : null;
    return hit ? String(hit).toUpperCase() : 'GUEST';
  }
  function customerKey() { return CUST?.id || CUST?.email || 'anon'; }
  const SERIAL_PAD = 5;
  const SKEY = p => `ND:SERIAL2:${customerKey()}:${p}`;
  function getState(p) {
    try { return JSON.parse(localStorage.getItem(SKEY(p)) || 'null') || null; }
    catch (_) { return null; }
  }
  function putState(p, st) { localStorage.setItem(SKEY(p), JSON.stringify(st)); }
  function currentSerial(p) {
    let st = getState(p);
    if (!st || st.prefix !== p) {
      st = { n: 1, pdf: false, xlsx: false, prefix: p };
      putState(p, st);
    }
    return `${p}-${String(st.n).padStart(SERIAL_PAD, '0')}`;
  }
  function done(which) {
    const p = prefixFromTags();
    let st = getState(p) || { n: 1, pdf: false, xlsx: false, prefix: p };
    if (which === 'pdf') st.pdf = true;
    if (which === 'xlsx') st.xlsx = true;
    st.n++;
    putState(p, st);
    return `${p}-${String(st.n).padStart(SERIAL_PAD, '0')}`;
  }
  const markPdfDone = () => done('pdf'); // 現在幾乎不會用到，只是保留

  async function fetchCart() {
    const r = await fetch('/cart.js?_=' + Date.now(), {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Cache-Control': 'no-cache' }
    });
    if (!r.ok) throw new Error('Failed to load /cart.js');
    return r.json();
  }

  async function uploadToCloud(fileBlob, filename, subpath, meta = {}) {
    if (!CLOUD_UPLOAD_ENABLED || !fileBlob) return { ok: true, skipped: true };
    const fileObj = (fileBlob instanceof File)
      ? fileBlob
      : new File([fileBlob], filename, { type: (fileBlob.type || 'application/pdf') });

    const fd = new FormData();
    fd.append('file', fileObj, fileObj.name);
    fd.append('path', subpath);
    fd.append('subpath', subpath);
    fd.append('filename', filename);
    fd.append('customer', customerEmail);
    if (meta.serial) fd.append('serial', meta.serial);
    if (meta.reference) fd.append('reference', meta.reference);

    const resp = await fetch(CLOUD_ENDPOINT, { method: 'POST', body: fd });
    if (!resp.ok) {
      let t = ''; try { t = await resp.text(); } catch (_) { }
      throw new Error(`Upload failed (${resp.status}) ${t.slice(0, 120)}`);
    }
    try { return await resp.json(); } catch (_) { return { ok: true }; }
  }

  function domRows() {
    return Array.from(document.querySelectorAll('#main-cart-items tbody tr.cart-item'));
  }
  function readPairs(tr) {
    const nodes = tr?.querySelectorAll('.product-option') || [];
    const out = [];
    nodes.forEach(n => {
      const k = n.querySelector('dt')?.textContent?.replace(/:\s*$/, '').trim() || '';
      const v = n.querySelector('dd')?.textContent?.trim() || '';
      if (!k) return;
      if (k.startsWith('_') || /^_+bss/i.test(k)) return;
      out.push([k, v]);
    });
    return out;
  }

  function readDimensionBlockFromCartRow(tr) {
  try {
    if (!tr) return { unitDim: '', roughOpening: '', glassDimension: '' };

    const text = tr.innerText || tr.textContent || '';
    if (!text) return { unitDim: '', roughOpening: '', glassDimension: '' };

    function pick(label) {
      const re = new RegExp(label + '\\s*:\\s*([^\\n\\r]+)', 'i');
      const m = text.match(re);
      return m ? String(m[1] || '').trim() : '';
    }

    return {
      unitDim: pick('Unit\\s*Dim\\.?'),
      roughOpening: pick('Rough\\s*Opening'),
      glassDimension: pick('Glass\\s*Dimension')
    };
  } catch (e) {
    console.warn('[ND PDF] readDimensionBlockFromCartRow failed', e);
    return { unitDim: '', roughOpening: '', glassDimension: '' };
  }
}

  function parseAddon(raw) {
    if (raw == null) return { clean: '', add: '' };
    let s = String(raw).trim();
    const re = /\(\s*\+\s*\$?\s*([0-9,]+(?:\.\d{1,2})?)\s*\)\s*$/g;
    let m, tot = 0;
    while ((m = re.exec(s)) !== null) {
      tot += parseFloat(m[1].replace(/,/g, '')) || 0;
    }
    s = s.replace(re, '').replace(/\s{2,}/g, ' ').trim();
    return { clean: s, add: tot ? tot.toFixed(2) : '' };
  }

  function buildDoorTypeCategoryMapForNoGlass() {
  const out = {};
  const map = window.NO_GLASS_DEDUCTION_MAP || {};

  Object.keys(map).forEach(category => {
    const categoryMap = map[category] || {};
    Object.keys(categoryMap).forEach(doorType => {
      out[doorType] = category;
    });
  });

  return out;
}

function getCategoryByDoorTypeForNoGlass(doorType) {
  return buildDoorTypeCategoryMapForNoGlass()[doorType] || '';
}

function normalizePanelTypeForNoGlass(raw) {
  const text = String(raw || '').toLowerCase().trim();
  if (/3\s*\/\s*4\s*lite|3\/4\s*lite|3\s*4\s*lite|three\s*quarter\s*lite/.test(text)) {
    return 'three_quarter_lite';
  }
  if (/full\s*view|full\s*lite/.test(text)) {
    return 'full_lite';
  }
  return '';
}

function normalizeDoorSizeForNoGlass(raw) {
  const m = String(raw || '').match(/\b\d{4,6}\b/);
  return m ? m[0] : '';
}

function normalizeDoorTypeForNoGlass(raw) {
  const text = String(raw || '').toLowerCase().trim();

  // 先支援直接 doorType 值
  if (getCategoryByDoorTypeForNoGlass(text)) return text;

  // hinged
  if (/single[\s_-]*hinged/.test(text)) return 'single_hinged';
  if (/double[\s_-]*hinged/.test(text)) return 'double_hinged';
  if (/center[\s_-]*hinged/.test(text)) return 'center_hinged';
  if (/vented[\s_-]*sidelight|venting[\s_-]*sidelight/.test(text)) return 'vented_sidelight';

  // new hinged
  if (/folding\s*door|folding[\s_-]*door|^folding$/.test(text)) return 'folding';

  // gliding
  if (/gliding\s*door\s*-\s*2\s*panels|gliding[\s_-]*2[\s_-]*panel/.test(text)) return 'gliding_2_panel';
  if (/gliding\s*door\s*-\s*3\s*panels|gliding[\s_-]*3[\s_-]*panel/.test(text)) return 'gliding_3_panel';
  if (/gliding\s*door\s*-\s*4\s*panels|gliding[\s_-]*4[\s_-]*panel/.test(text)) return 'gliding_4_panel';

  // new gliding
  if (
    /bypass\s*gliding\s*door|bypass[\s_-]*gliding[\s_-]*door|gliding[\s_-]*bypass|bypass[\s_-]*gliding/.test(text)
  ) return 'gliding_bypass';

  // fixed
  if (/fixed\s*\(?\s*gliding\s*\)?\s*-\s*1\s*panel/.test(text)) return 'gliding_one_panel';
  if (/fixed\s*-\s*1\s*panel/.test(text)) return 'hinged_one_panel';
  if (/fixed\s*-\s*2\s*panels/.test(text)) return 'hinged_two_panel';
  if (/fixed\s*-\s*3\s*panels/.test(text)) return 'hinged_three_panel';

  return '';
}

function getTitleTextFromRowForNoGlass(tr) {
  if (!tr) return '';
  return (
    tr.querySelector('.cart-item__name')?.textContent ||
    tr.querySelector('.cart-item__details a')?.textContent ||
    tr.querySelector('.cart-item__details')?.textContent ||
    ''
  ).trim();
}

function getNoGlassDeductionCentsFromPairs(pairs, tr) {
  try {
    const map = window.NO_GLASS_DEDUCTION_MAP || {};

    let size = '';
    let panelType = '';
    let glassValue = '';
    let doorType = '';

    (pairs || []).forEach(([k, v]) => {
      const kk = String(k || '');
      const vv = String(v || '');

      if (!size && /door\s*size/i.test(kk)) {
        size = normalizeDoorSizeForNoGlass(vv);
      }

      if (!panelType && /panel\s*type/i.test(kk)) {
        panelType = normalizePanelTypeForNoGlass(vv);
      }

      if (!glassValue && /glass\s*option/i.test(kk)) {
        glassValue = vv;
      }

      if (!doorType && /door\s*type/i.test(kk)) {
        doorType = normalizeDoorTypeForNoGlass(vv);
      }
    });

    if (!doorType) {
      doorType = normalizeDoorTypeForNoGlass(getTitleTextFromRowForNoGlass(tr));
    }

    const category = getCategoryByDoorTypeForNoGlass(doorType);

    if (!/no\s*glass/i.test(String(glassValue || ''))) return 0;
    if (!category || !doorType || !size || !panelType) return 0;

    const dollars = Number(
      map?.[category]?.[doorType]?.[size]?.[panelType] || 0
    );

    if (window.NO_GLASS_DEBUG_MODE) {
      console.log('[ND PDF][NoGlass]', {
        title: getTitleTextFromRowForNoGlass(tr),
        category,
        doorType,
        size,
        panelType,
        glassValue,
        dollars
      });
    }

    return Math.round(dollars * 100);
  } catch (e) {
    console.warn('[ND PDF] no-glass deduction parse failed', e);
    return 0;
  }
}

function normalizePanelTypeForUnitDim(raw) {
  const text = String(raw || '').toLowerCase().trim();
  if (/3\s*\/\s*4\s*lite|3\/4\s*lite|3\s*4\s*lite|three\s*quarter\s*lite/.test(text)) {
    return 'three_quarter_lite';
  }
  if (/full\s*view|full\s*lite/.test(text)) {
    return 'full_lite';
  }
  return '';
}

function normalizeDoorSizeForUnitDim(raw) {
  const m = String(raw || '').match(/\b\d{4,6}\b/);
  return m ? m[0] : '';
}

function normalizeSwingForUnitDim(raw) {
  const text = String(raw || '').toLowerCase().trim();
  if (/out\s*swing|outswing/.test(text)) return 'outswing';
  if (/in\s*swing|inswing/.test(text)) return 'inswing';
  return 'all';
}

function normalizeDoorTypeForUnitDim(raw) {
  const text = String(raw || '').toLowerCase().trim();

  if (/single[\s_-]*hinged/.test(text)) return { group: 'hinged', style: 'single_hinged' };
  if (/double[\s_-]*hinged/.test(text)) return { group: 'hinged', style: 'double_hinged' };
  if (/vented[\s_-]*sidelight|venting[\s_-]*sidelight/.test(text)) {
    return { group: 'hinged', style: 'vented_sidelight' };
  }
  if (/center[\s_-]*hinged.*2\s*panels?|center[\s_-]*hinged.*2\s*panel/.test(text)) {
    return { group: 'hinged', style: 'center_hinged_2_panel' };
  }
  if (/center[\s_-]*hinged.*3\s*panels?|center[\s_-]*hinged.*3\s*panel/.test(text)) {
    return { group: 'hinged', style: 'center_hinged_3_panel' };
  }

  if (/bypass\s*gliding/.test(text)) return { group: 'gliding', style: 'bypass_gliding' };
  if (/gliding\s*door.*2\s*panels?|gliding.*2\s*panel/.test(text)) return { group: 'gliding', style: 'gliding_2_panel' };
  if (/gliding\s*door.*3\s*panels?|gliding.*3\s*panel/.test(text)) return { group: 'gliding', style: 'gliding_3_panel' };
  if (/gliding\s*door.*4\s*panels?|gliding.*4\s*panel/.test(text)) return { group: 'gliding', style: 'gliding_4_panel' };

  if (/fixed\s*\(?\s*gliding\s*\)?\s*-\s*1\s*panel/.test(text)) return { group: 'fixed', style: 'gliding_one_panel' };
  if (/fixed\s*-\s*1\s*panel/.test(text)) return { group: 'fixed', style: 'hinged_one_panel' };
  if (/fixed\s*-\s*2\s*panels?/.test(text)) return { group: 'fixed', style: 'hinged_two_panel' };
  if (/fixed\s*-\s*3\s*panels?/.test(text)) return { group: 'fixed', style: 'hinged_three_panel' };

  if (/transom\s*-\s*1\s*lite/.test(text)) return { group: 'transom', style: 'transom_1_lite' };
  if (/transom\s*-\s*2\s*lite/.test(text)) return { group: 'transom', style: 'transom_2_lite' };
  if (/transom\s*-\s*3\s*lite/.test(text)) return { group: 'transom', style: 'transom_3_lite' };
  if (/transom\s*-\s*4\s*lite/.test(text)) return { group: 'transom', style: 'transom_4_lite' };

  return { group: '', style: '' };
}

function getTitleTextFromRowForUnitDim(tr, item) {
  if (tr) {
    const t =
      tr.querySelector('.cart-item__name')?.textContent ||
      tr.querySelector('.cart-item__details a')?.textContent ||
      tr.querySelector('.cart-item__details')?.textContent ||
      '';
    if (String(t || '').trim()) return String(t).trim();
  }
  return String(item?.product_title || item?.title || '').trim();
}

function getUnitDimensionFromPairs(pairs, tr, item) {
  try {
    const map = window.UNIT_DIMENSION_MAP || {};

    let size = '';
    let panelType = '';
    let swing = '';
    let ctx = { group: '', style: '' };

    (pairs || []).forEach(([k, v]) => {
      const kk = String(k || '');
      const vv = String(v || '');

      if (!size && /door\s*size/i.test(kk)) {
        size = normalizeDoorSizeForUnitDim(vv);
      }

      if (!panelType && /panel\s*type/i.test(kk)) {
        panelType = normalizePanelTypeForUnitDim(vv);
      }

      if (!swing && /^swing$/i.test(kk)) {
        swing = normalizeSwingForUnitDim(vv);
      }

      if (!ctx.style && /door\s*type/i.test(kk)) {
        ctx = normalizeDoorTypeForUnitDim(vv);
      }
    });

    if (!ctx.style) {
      ctx = normalizeDoorTypeForUnitDim(getTitleTextFromRowForUnitDim(tr, item));
    }

    if (!ctx.group || !ctx.style || !size) return '';

    const sizeNode = map?.[ctx.group]?.[ctx.style]?.[size];
    if (!sizeNode) return '';

    function pickString(node) {
      if (!node) return '';

      if (typeof node === 'string') return node;

      if (typeof node !== 'object') return '';

      if (swing && typeof node[swing] === 'string') return node[swing];
      if (typeof node.all === 'string') return node.all;

      const keys = Object.keys(node);
      for (const key of keys) {
        const val = pickString(node[key]);
        if (val) return val;
      }

      return '';
    }

    // 先走 panelType
    if (panelType && sizeNode[panelType]) {
      return pickString(sizeNode[panelType]);
    }

    // 再直接從 sizeNode 往下找字串
    return pickString(sizeNode);
  } catch (e) {
    console.warn('[ND PDF] getUnitDimensionFromPairs failed', e);
    return '';
  }
}
function getRoughOpeningFromPairs(pairs, tr, item) {
  try {
    const map =
      window.ROUGH_OPENING_MAP ||
      window.ROUGH_OPENING_DIMENSION_MAP ||
      {};

    let size = '';
    let panelType = '';
    let swing = '';
    let ctx = { group: '', style: '' };

    (pairs || []).forEach(([k, v]) => {
      const kk = String(k || '');
      const vv = String(v || '');

      if (!size && /door\s*size/i.test(kk)) {
        size = normalizeDoorSizeForUnitDim(vv);
      }

      if (!panelType && /panel\s*type/i.test(kk)) {
        panelType = normalizePanelTypeForUnitDim(vv);
      }

      if (!swing && /^swing$/i.test(kk)) {
        swing = normalizeSwingForUnitDim(vv);
      }

      if (!ctx.style && /door\s*type/i.test(kk)) {
        ctx = normalizeDoorTypeForUnitDim(vv);
      }
    });

    if (!ctx.style) {
      ctx = normalizeDoorTypeForUnitDim(getTitleTextFromRowForUnitDim(tr, item));
    }

    if (!ctx.group || !ctx.style || !size) return '';

    const sizeNode = map?.[ctx.group]?.[ctx.style]?.[size];
    if (!sizeNode) return '';

    function pickString(node) {
      if (!node) return '';
      if (typeof node === 'string') return node;
      if (typeof node !== 'object') return '';

      if (swing && typeof node[swing] === 'string') return node[swing];
      if (typeof node.all === 'string') return node.all;

      const keys = Object.keys(node);
      for (const key of keys) {
        const val = pickString(node[key]);
        if (val) return val;
      }
      return '';
    }

    if (panelType && sizeNode[panelType]) {
      return pickString(sizeNode[panelType]);
    }

    return pickString(sizeNode);
  } catch (e) {
    console.warn('[ND PDF] getRoughOpeningFromPairs failed', e);
    return '';
  }
}

function getGlassDimensionFromPairs(pairs, tr, item) {
  try {
    const map =
      window.GLASS_DIMENSION_MAP ||
      window.GLASS_DIM_MAP ||
      {};

    let size = '';
    let panelType = '';
    let swing = '';
    let ctx = { group: '', style: '' };

    (pairs || []).forEach(([k, v]) => {
      const kk = String(k || '');
      const vv = String(v || '');

      if (!size && /door\s*size/i.test(kk)) {
        size = normalizeDoorSizeForUnitDim(vv);
      }

      if (!panelType && /panel\s*type/i.test(kk)) {
        panelType = normalizePanelTypeForUnitDim(vv);
      }

      if (!swing && /^swing$/i.test(kk)) {
        swing = normalizeSwingForUnitDim(vv);
      }

      if (!ctx.style && /door\s*type/i.test(kk)) {
        ctx = normalizeDoorTypeForUnitDim(vv);
      }
    });

    if (!ctx.style) {
      ctx = normalizeDoorTypeForUnitDim(getTitleTextFromRowForUnitDim(tr, item));
    }

    if (!ctx.group || !ctx.style || !size) return '';

    const sizeNode = map?.[ctx.group]?.[ctx.style]?.[size];
    if (!sizeNode) return '';

    function pickString(node) {
      if (!node) return '';
      if (typeof node === 'string') return node;
      if (typeof node !== 'object') return '';

      if (swing && typeof node[swing] === 'string') return node[swing];
      if (typeof node.all === 'string') return node.all;

      const keys = Object.keys(node);
      for (const key of keys) {
        const val = pickString(node[key]);
        if (val) return val;
      }
      return '';
    }

    if (panelType && sizeNode[panelType]) {
      return pickString(sizeNode[panelType]);
    }

    return pickString(sizeNode);
  } catch (e) {
    console.warn('[ND PDF] getGlassDimensionFromPairs failed', e);
    return '';
  }
}

function getRoughOpeningFromPairs(pairs, tr, item) {
  try {
    const map =
      window.ROUGH_OPENING_MAP ||
      window.ROUGH_OPENING_DIMENSION_MAP ||
      {};

    let size = '';
    let panelType = '';
    let swing = '';
    let ctx = { group: '', style: '' };

    (pairs || []).forEach(([k, v]) => {
      const kk = String(k || '');
      const vv = String(v || '');

      if (!size && /door\s*size/i.test(kk)) {
        size = normalizeDoorSizeForUnitDim(vv);
      }

      if (!panelType && /panel\s*type/i.test(kk)) {
        panelType = normalizePanelTypeForUnitDim(vv);
      }

      if (!swing && /^swing$/i.test(kk)) {
        swing = normalizeSwingForUnitDim(vv);
      }

      if (!ctx.style && /door\s*type/i.test(kk)) {
        ctx = normalizeDoorTypeForUnitDim(vv);
      }
    });

    if (!ctx.style) {
      ctx = normalizeDoorTypeForUnitDim(getTitleTextFromRowForUnitDim(tr, item));
    }

    if (!ctx.group || !ctx.style || !size) return '';

    const sizeNode = map?.[ctx.group]?.[ctx.style]?.[size];
    if (!sizeNode) return '';

    if (typeof sizeNode === 'string') return sizeNode;

    if (panelType && sizeNode[panelType]) {
      const panelNode = sizeNode[panelType];
      return panelNode?.[swing || 'all'] || panelNode?.all || '';
    }

    if (sizeNode[swing || 'all'] || sizeNode.all) {
      return sizeNode[swing || 'all'] || sizeNode.all || '';
    }

    const keys = Object.keys(sizeNode || {});
    if (keys.length === 1) {
      const onlyNode = sizeNode[keys[0]];
      if (typeof onlyNode === 'string') return onlyNode;
      return onlyNode?.[swing || 'all'] || onlyNode?.all || '';
    }

    return '';
  } catch (e) {
    console.warn('[ND PDF] getRoughOpeningFromPairs failed', e);
    return '';
  }
}

function getGlassDimensionFromPairs(pairs, tr, item) {
  try {
    const map =
      window.GLASS_DIMENSION_MAP ||
      window.GLASS_DIM_MAP ||
      {};

    let size = '';
    let panelType = '';
    let swing = '';
    let ctx = { group: '', style: '' };

    (pairs || []).forEach(([k, v]) => {
      const kk = String(k || '');
      const vv = String(v || '');

      if (!size && /door\s*size/i.test(kk)) {
        size = normalizeDoorSizeForUnitDim(vv);
      }

      if (!panelType && /panel\s*type/i.test(kk)) {
        panelType = normalizePanelTypeForUnitDim(vv);
      }

      if (!swing && /^swing$/i.test(kk)) {
        swing = normalizeSwingForUnitDim(vv);
      }

      if (!ctx.style && /door\s*type/i.test(kk)) {
        ctx = normalizeDoorTypeForUnitDim(vv);
      }
    });

    if (!ctx.style) {
      ctx = normalizeDoorTypeForUnitDim(getTitleTextFromRowForUnitDim(tr, item));
    }

    if (!ctx.group || !ctx.style || !size) return '';

    const sizeNode = map?.[ctx.group]?.[ctx.style]?.[size];
    if (!sizeNode) return '';

    if (typeof sizeNode === 'string') return sizeNode;

    if (panelType && sizeNode[panelType]) {
      const panelNode = sizeNode[panelType];
      return panelNode?.[swing || 'all'] || panelNode?.all || '';
    }

    if (sizeNode[swing || 'all'] || sizeNode.all) {
      return sizeNode[swing || 'all'] || sizeNode.all || '';
    }

    const keys = Object.keys(sizeNode || {});
    if (keys.length === 1) {
      const onlyNode = sizeNode[keys[0]];
      if (typeof onlyNode === 'string') return onlyNode;
      return onlyNode?.[swing || 'all'] || onlyNode?.all || '';
    }

    return '';
  } catch (e) {
    console.warn('[ND PDF] getGlassDimensionFromPairs failed', e);
    return '';
  }
}

  // ★★ 只針對「上方 Reference Number」
  function readReferenceFallbackFromDOM() {
    const sels = [
      'input[name="attributes[Reference Number]"]',
      'input[name="attributes[reference_number]"]',
      '#Cart-reference-number',
      'input#Cart-reference-number',
      '[data-ref-number]'
    ];
    for (const s of sels) {
      const el = document.querySelector(s);
      if (el && typeof el.value === 'string') {
        const v = el.value.trim();
        if (v) return v;
      }
    }
    return '';
  }

  // Special Instruction（下面的 note）
  function readSpecialInstructionFromDOM() {
    const sels = [
      '#Cart-note',
      'textarea#Cart-note',
      'textarea[name="note"]',
      'textarea[name="attributes[Special Instruction]"]',
      'textarea[name="attributes[special_instruction]"]',
      '[data-special-instruction]'
    ];
    for (const s of sels) {
      const el = document.querySelector(s);
      if (el && typeof el.value === 'string') {
        const v = el.value.trim();
        if (v) return v;
      }
    }
    return '';
  }

  // 上方運送資訊
  function readShippingInfoFromDOM() {
    function val(selectors) {
      for (const sel of selectors) {
        const el = document.querySelector(sel);
        if (el && typeof el.value === 'string') {
          const v = el.value.trim();
          if (v) return v;
        }
      }
      return '';
    }
    const contact = val([
      'input[name="attributes[Shipping Contact Name]"]',
      'input[name="attributes[Contact Name]"]',
      'input[name="attributes[contact_name]"]',
      '[data-nd-contact]'
    ]);
    const phone = val([
      'input[name="attributes[Shipping Phone]"]',
      'input[name="attributes[Phone Number]"]',
      'input[name="attributes[phone_number]"]',
      '[data-nd-phone]'
    ]);
    const company = val([
      'input[name="attributes[Company Name]"]',
      '[data-nd-company]'
    ]);
    const address = val([
      'textarea[name="attributes[Shipping Address]"]',
      'textarea[name="attributes[shipping_address]"]',
      '[data-nd-shipaddr]'
    ]);
    return { contact, phone, company, address };
  }

  // fuzzy key match：把空白 / 底線拔掉再比對
  function pickAttr(attrs, domVal, candidates) {
    if (domVal && String(domVal).trim()) return String(domVal).trim();
    const normKey = k => String(k || '').toLowerCase().replace(/[\s_]+/g, '');
    const wants = (candidates || []).map(normKey);
    const keys = Object.keys(attrs || {});
    for (const k of keys) {
      const nk = normKey(k);
      if (wants.includes(nk)) {
        const v = attrs[k];
        if (typeof v === 'string' && v.trim()) return v.trim();
      }
    }
    return '';
  }

  async function ensurePdfLibs() {
    if (!window.jspdf) {
      await new Promise((res, rej) => {
        const s = document.createElement('script');
        s.src = 'https://cdn.jsdelivr.net/npm/jspdf@2.5.1/dist/jspdf.umd.min.js';
        s.onload = res; s.onerror = () => rej(new Error('jsPDF 載入失敗'));
        document.head.appendChild(s);
      });
    }
    if (!window.jspdf?.autoTable) {
      await new Promise((res, rej) => {
        const s = document.createElement('script');
        s.src = 'https://cdn.jsdelivr.net/npm/jspdf-autotable@3.8.2/dist/jspdf.plugin.autotable.min.js';
        s.onload = res; s.onerror = () => rej(new Error('autoTable 載入失敗'));
        document.head.appendChild(s);
      });
    }
  }

  const FACTOR_KEY = 'cart_discount_factor_v1';
  function sanitizeDecimal(str) {
    str = String(str || '').replace(/[^0-9.]/g, '');
    const parts = str.split('.');
    if (parts.length > 2) str = parts.shift() + '.' + parts.join('');
    if (str.startsWith('.')) str = '0' + str;
    return str;
  }
  function clamp3(n) {
    n = Math.max(0, Math.min(9.999, Number(n)));
    return Number(n.toFixed(3));
  }
  function readLiveFactor() {
    const el = document.querySelector('#nd-factor-input,[name="nd-factor"],input[data-nd-factor],input[name="attributes[factor]"]');
    if (el && typeof el.value === 'string') {
      const raw = sanitizeDecimal(el.value);
      if (raw === '') {
        try { localStorage.removeItem(FACTOR_KEY); } catch (_) { }
        return 1.000;
      }
      const n = parseFloat(raw);
      return Number.isFinite(n) ? clamp3(n) : 1.000;
    }
    const ls = parseFloat(localStorage.getItem(FACTOR_KEY));
    return Number.isFinite(ls) ? clamp3(ls) : 1.000;
  }

  /* ---------- NEW: 只修「選配名稱」的 dash 後段，不影響值與其他結構 ---------- */
  const trimDashName = (s) => s == null ? s : String(s).replace(/\s-\s.*$/, '').trim();

  // ---- ND PDF export: hide internal properties (uuid/_bss/_nd/etc) ----
  function __ndNormalizeKey(k){
    return String(k || '').trim().toLowerCase();
  }
  function __ndShouldSkipExportPropKey(k){
    var kk = __ndNormalizeKey(k);

    // exact
    if (kk === 'uuid') return true;

    // bss/nd internals
    if (kk.indexOf('_bss') === 0) return true;
    if (kk.indexOf('bss_') === 0) return true;

    if (kk.indexOf('_nd') === 0) return true;
    if (kk.indexOf('nd_') === 0) return true;
    if (kk.indexOf('nd:') === 0) return true;

    // common markers used in reload/replace flows
    if (kk.indexOf('nd_reload') !== -1) return true;
    if (kk.indexOf('pending_replace') !== -1) return true;

    return false;
  }

  // 🔓 expose to window for PDF + console test
 window.calcLineBySSOTFromDOM = function (tr, qty, factor) {
  const options = [];
  const pairs = [];

  if (tr) {
    tr.querySelectorAll('.product-option').forEach(node => {
      const name = node.querySelector('dt')?.textContent
        ?.replace(/:\s*$/, '')
        .trim();
      const rawVal = node.querySelector('dd')?.textContent?.trim();

      if (!name || !rawVal) return;

      const nk = name.toLowerCase();
      if (nk === 'uuid' || nk.startsWith('_')) return;
      if (__ndShouldSkipExportPropKey(name)) return;

      pairs.push([name, rawVal]);

      const p = parseAddon(rawVal);
      if (!p.add) return;

      options.push({
        name,
        value: p.clean,
        rawCents: Math.round(Number(p.add) * 100)
      });
    });
  }

  // No Glass deduction：依新 mapping 規則查表
  const noGlassDeductionCents = getNoGlassDeductionCentsFromPairs(pairs, tr);
  if (noGlassDeductionCents > 0) {
    options.push({
      name: 'No Glass Deduction',
      value: 'Deduction',
      rawCents: -noGlassDeductionCents
    });
  }

  return window.ND_EXPORT_SSOT.calc({
    options,
    factor,
    qty
  });
};

  /* ---------- ★ NEW: per-unit rounding 計算（你們系統要的） ---------- */
  function calcLineAfterFactorPerUnit(item, factor) {
    const qty = Number(item?.quantity || 0);
    const unitCents = Number(item?.final_price ?? item?.price ?? 0); // 單件 cents（含選配/折扣後）
    const unitAfterCents = Math.round(unitCents * factor);           // 單價先乘 factor → round 到 cents
    const lineAfterCents = unitAfterCents * qty;                     // 再乘 qty
    return { qty, unitCents, unitAfterCents, lineAfterCents };
  }
  function calcSubtotalAfterFactorPerUnit(cart, factor) {
    let sum = 0;
    for (const it of (cart?.items || [])) {
      const r = calcLineAfterFactorPerUnit(it, factor);
      if (r.qty) sum += r.lineAfterCents;
    }
    return sum;
  }

  /* ---------- 取圖（pt→px，含各型式加成） ---------- */
  function prioritizeUrls(list) {
    const arr = Array.from(new Set((list || []).filter(Boolean)));
    const key = /(need_drawing|_equal_lite|_4_lite_tall|_9_lite_prairie)/i;
    const score = (u) => (key.test(u) ? 300 : 0)
      + (/-FULL(\.|$)/i.test(u) ? 100 : 0)
      + (/(\.|-|_)34(\.|$)/i.test(u) ? 50 : 0);
    return arr.sort((a, b) => score(b) - score(a));
  }
  function panelBonus(u) {
    if (isFourPanel(u)) return { w: P4_W_BONUS, h: P4_H_BONUS };
    if (isThreePanel(u)) return { w: P3_W_BONUS, h: P3_H_BONUS };
    return { w: 0, h: 0 };
  }
  async function buildImageMap(cart, trs) {
    const map = {};
    const ND = window.NDIMG;
    async function one(u, targetPtW) {
      try {
        const px = Math.round(ptToPx(targetPtW) * FETCH_OVERSCALE);
        const b64 = await ND.urlToBase64PNG(u, px);
        return b64 ? ('data:image/png;base64,' + b64) : null;
      } catch (_) { return null; }
    }
    for (let i = 0; i < (cart.items || []).length; i++) {
      const it = cart.items[i];
      const rowEl = (trs && trs[i]) ? trs[i] : null;
      const domPairs = rowEl ? readPairs(rowEl) : [];
      let urls = ND && ND.getItemImageUrls ? ND.getItemImageUrls(it, domPairs, rowEl) : [];
      urls = prioritizeUrls(urls);
      const out = [];
      for (const u of urls) {
        const suggestedLandscape = /need_drawing|^.*\/DGT/i.test(u);
        const basePtW = suggestedLandscape ? BASE_LAND_W : BASE_PORT_W;

        const pb = panelBonus(u);
        const bonusW = (isTransomUrl(u) ? TRANSOM_W_BONUS : 0) + pb.w;
        const targetPtW = (basePtW + bonusW) * IMG_SCALE;

        const du = await one(u, targetPtW);
        if (du) {
          out.push({
            dataUrl: du,
            isLandscape: suggestedLandscape || isTransomUrl(u) || isThreePanel(u) || isFourPanel(u),
            isPattern: /(need_drawing|_equal_lite|_4_lite_tall|_9_lite_prairie)/i.test(u),
            url: u
          });
          if (out.length >= 3) break;
        }
      }
      if (out.length) map[i + 1] = out;
    }
    return map;
  }

  // 右側區塊 X/W/Y
  function getRightBlockXYW(data) {
    const cellUnit = data.row.cells['5'];
    const cellLine = data.row.cells['6'];
    if (!cellUnit || !cellLine) return null;
    const x = cellUnit.x + RCOL_PAD;
    const w = (cellLine.x + cellLine.width) - cellUnit.x - (RCOL_PAD * 2);
    const y = cellUnit.y;
    return { x, w, y, page: data.pageNumber };
  }

  /* ---------- 主流程：產 PDF ---------- */
  async function exportPDF() {
    const cart = await fetchCart();
    if (!cart?.items?.length) { alert('Cart is empty'); return; }

    // ★★ Quote #：優先使用 GAS 回傳的正式編號；
    //     如果目前還沒有，也照樣匯出 PDF，只是用 DRAFT-日期 當作編號顯示（不再本機跑號）。
    const officialNo = getOfficialQuoteNo();

    let fileQuoteNo;
    let serialShort;
    let prefix = 'DRAFT';

    if (officialNo) {
      fileQuoteNo = officialNo;
      serialShort = officialNo;
      prefix = officialNo.split('-')[0];
    } else {
      const today = fmtMDY();
      fileQuoteNo = `DRAFT-${today}`;
      serialShort = fileQuoteNo;
    }

    await ensurePdfLibs();
const { jsPDF } = window.jspdf;
const doc = new jsPDF({ unit: 'pt', format: 'a4', compress: true });

const exportBrandWithLogo = window.ND_getExportBrandWithLogoData
  ? await window.ND_getExportBrandWithLogoData()
  : null;

const COMPANY = 'Neuma Doors';
const BRAND_LOGO_DATA_URL = exportBrandWithLogo?.logoDataUrl || '';

const margin = { top: 140, right: 36, bottom: 60, left: 36 };
    const pageW = doc.internal.pageSize.getWidth();
    const contentW = pageW - margin.left - margin.right;

    const dateStr = fmtMDY();

    const attrs = (cart && cart.attributes) || {};
    const shipDom = readShippingInfoFromDOM();

    const shipContact = pickAttr(attrs, shipDom.contact,
      ['Shipping Contact Name', 'Contact Name', 'contact_name', 'contact']);
    const shipPhone = pickAttr(attrs, shipDom.phone,
      ['Shipping Phone', 'Phone Number', 'phone_number', 'Phone', 'phone']);
    const shipCompany = pickAttr(attrs, shipDom.company,
      ['Company Name', 'company_name', 'Company']);
    const shipAddress = pickAttr(attrs, shipDom.address,
      ['Shipping Address', 'shipping_address', 'Address']);

    const shippingLines = [];
    if (shipContact) shippingLines.push('Contact Name : ' + shipContact);
    if (shipCompany) shippingLines.push('Company Name : ' + shipCompany);
    if (shipAddress) shippingLines.push('Address : ' + shipAddress);
    if (shipPhone) shippingLines.push('Phone : ' + shipPhone);

    const refDOM = readReferenceFallbackFromDOM();
    const refAttr = pickAttr(attrs, '', ['Reference Number', 'reference_number', 'Reference']);
    const refRaw = (refDOM || refAttr || '').trim();
    const refShort = refRaw ? refRaw.slice(0, 120) : '';

    const specialDom = readSpecialInstructionFromDOM();
    const specialJson = (cart && typeof cart.note === 'string') ? cart.note.trim() : '';
    const specialRaw = (specialDom || specialJson || '').trim();

    const FACTOR = readLiveFactor();
    window.__ND_FACTOR_EFFECTIVE__ = FACTOR;
    try { localStorage.setItem(FACTOR_KEY, String(FACTOR)); } catch (_) { }

    const head = [['Line', 'Product', 'Option Value', 'Quantity', 'Add-on Price', 'Unit price', 'Line price']];
    const body = []; const trs = domRows(); const preImageMap = await buildImageMap(cart, trs);

    (cart.items || []).forEach((it, idx) => {
      const seen = new Set(); const detailRows = []; let optIdx = 0;

      const feed = (label, raw) => {
        const lab = String(label || '').trim(); if (!lab) return;

        // ★ PATCH: Hide uuid/_bss/_nd/nd: keys from export (applies to DOM/options/properties)
        if (__ndShouldSkipExportPropKey(lab)) return;

        if (lab.startsWith('_') || /^_+bss/i.test(lab)) return;
        const p = parseAddon(raw);
        if (norm(lab) === 'title' || norm(p.clean) === 'default title') return;
        if (norm(lab) === 'unit dim.' || norm(lab) === 'unit dim') return;

        const dispLab = trimDashName(lab);

        const key = `${norm(dispLab)}|${norm(p.clean || raw || '')}`;
        if (seen.has(key)) return;
        seen.add(key);

        let addNum = 0;
        if (p.add) {
          // Add-on Price 顯示用：美元 * factor → 小數兩位
          addNum = Math.round(parseFloat(p.add || '0') * 100 * FACTOR) / 100;
        }
        const addCell = (optIdx === 0)
          ? ''
          : (addNum ? `$${fmtMoney(addNum)}` : '');

        detailRows.push([
          '',
          '· ' + dispLab,
          (p.clean || '').trim(),
          '',
          addCell,
          '',
          ''
        ]);
        optIdx++;
      };

      const rowEl = (trs.length && trs[idx]) ? trs[idx] : null;
      const domPairs = rowEl ? readPairs(rowEl) : null;
      if (domPairs && domPairs.length) {
        domPairs.forEach(([k, v]) => feed(k, v));
      } else {
        (it.options_with_values || []).forEach(o => {
          if (o) feed(o.name || '', o.value || '');
        });
        const props = it.properties || {};
        if (Array.isArray(props)) {
          props.forEach(p => feed(p?.name ?? p?.key ?? '', p?.value ?? p?.val ?? p?.last));
        } else if (typeof props === 'object') {
          Object.keys(props).forEach(k => feed(k, props[k]));
        }
      }

      function hasDetailLabel(rows, label) {
  const target = String(label || '').toLowerCase().replace(/\s+/g, ' ').trim();
  return (rows || []).some(r => {
    const text = String(r?.[1] || '')
      .replace(/^·\s*/, '')
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .trim();
    return text === target;
  });
}

const dimBlock = readDimensionBlockFromCartRow(rowEl);

const unitDim =
  dimBlock.unitDim ||
  getUnitDimensionFromPairs(domPairs || [], rowEl, it);

if (unitDim && !hasDetailLabel(detailRows, 'Unit Dim.') && !hasDetailLabel(detailRows, 'Unit Dim')) {
  detailRows.push([
    '',
    '· Unit Dim.',
    unitDim,
    '',
    '',
    '',
    ''
  ]);
}

const roughOpening =
  dimBlock.roughOpening ||
  '';

if (roughOpening && !hasDetailLabel(detailRows, 'Rough Opening')) {
  detailRows.push([
    '',
    '· Rough Opening',
    roughOpening,
    '',
    '',
    '',
    ''
  ]);
}

const glassDimension =
  dimBlock.glassDimension ||
  '';

if (glassDimension && !hasDetailLabel(detailRows, 'Glass Dimension')) {
  detailRows.push([
    '',
    '· Glass Dimension',
    glassDimension,
    '',
    '',
    '',
    ''
  ]);
}
      const noGlassDeductionCents = getNoGlassDeductionCentsFromPairs(domPairs || [], rowEl);
if (noGlassDeductionCents > 0) {
  const noGlassDisplay = Math.round(noGlassDeductionCents * FACTOR) / 100;

  detailRows.push([
    '',
    '· No Glass Credit',
    'Deduction',
    '',
    `-$${fmtMoney(noGlassDisplay)}`,
    '',
    ''
  ]);
}
      const lineNo = idx + 1;
const title = String(it.product_title || it.title || '');
const qty = it.quantity || 0;

const tr = trs[idx] || null;
const ssot = calcLineBySSOTFromDOM(tr, qty, FACTOR);

const unit = `$${money2(ssot.unitCents)}`;
const lineTotal = `$${money2(ssot.lineCents)}`;


      const main = [
        { content: String(lineNo), styles: { fontStyle: 'bold' } },
        { content: title, colSpan: 2, styles: { fontStyle: 'bold' } },
        { content: String(qty), styles: { halign: 'center', fontStyle: 'bold' } },
        { content: '', styles: { halign: 'right', fontStyle: 'bold' } },
        { content: unit, styles: { halign: 'center', fontStyle: 'bold' } },
        { content: lineTotal, styles: { halign: 'center', fontStyle: 'bold' } }
      ];
      main.__isMain = true;
      main.__lineNo = lineNo;
      body.push(main);
      detailRows.forEach(r => body.push(r));
    });

    // ★ Estimated total：per-unit rounding 加總
    let estimatedAfter = 0;
(cart.items || []).forEach((it, idx) => {
  const tr = trs[idx] || null;
  const qty = it.quantity || 0;
  const ssot = calcLineBySSOTFromDOM(tr, qty, FACTOR);
  estimatedAfter += ssot.lineCents;
});

    body.push([
      { content: 'Estimated total', colSpan: 6, styles: { halign: 'right', fontStyle: 'bold' } },
      { content: `$${money2(estimatedAfter)}`, styles: { halign: 'center', fontStyle: 'bold' } }
    ]);

    const W_LINE = 34, W_QTY = 52, W_UNIT = 80, W_ADD = 86, W_LINEPRICE = 80, W_VAL = 120;
    const fixedSum = W_LINE + W_QTY + W_UNIT + W_ADD + W_LINEPRICE + W_VAL;
    const W_PRODUCT = Math.max(90, contentW - fixedSum);

    let currentLineNo = 0;
    const rightBlock = {};
    const doorAnchor = {};
    const lineBottom = {};
    const pendingMain = [];
    const lastRBPerPage = {};
    const imgBottomByPage = {};

    doc.setFont('helvetica', 'normal');
    doc.setFontSize(9.0);
    doc.autoTable({
      startY: margin.top,
      head, body, margin,
      styles: {
        font: 'helvetica',
        fontSize: 9.0,
        cellPadding: 3.0,
        lineColor: [200, 200, 200],
        lineWidth: 0.6,
        overflow: 'linebreak',
        valign: 'top'
      },
      headStyles: {
        fillColor: [246, 246, 246],
        textColor: [20, 20, 20],
        lineColor: [180, 180, 180],
        lineWidth: 1,
        halign: 'center'
      },
      columnStyles: {
        0: { cellWidth: W_LINE, halign: 'center' },
        1: { cellWidth: W_PRODUCT },
        2: { cellWidth: W_VAL },
        3: { cellWidth: W_QTY, halign: 'center' },
        4: { cellWidth: W_ADD, halign: 'right' },
        5: { cellWidth: W_UNIT, halign: 'center' },
        6: { cellWidth: W_LINEPRICE, halign: 'center' }
      },

      didDrawPage: (data) => {
        const y0 = 30, rx = pageW - margin.right;

if (BRAND_LOGO_DATA_URL) {
  try {
    const logoW = 120;
    const logoH = 40;
    const logoY = y0 - 18;

    doc.addImage(
      BRAND_LOGO_DATA_URL,
      'PNG',
      margin.left,
      logoY,
      logoW,
      logoH,
      undefined,
      'FAST'
    );
  } catch (e) {
    console.warn('[ND PDF] brand logo draw failed', e);

    doc.setFont('helvetica', 'bold');
    doc.setFontSize(16);
    doc.setTextColor(20);
    doc.text(COMPANY, margin.left, y0);
  }
} else {
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(16);
  doc.setTextColor(20);
  doc.text(COMPANY, margin.left, y0);
}

        doc.setFont('helvetica', 'normal');
        doc.setFontSize(10);
        doc.text(`Quotation # : ${serialShort}`, rx, y0, { align: 'right' });
        doc.text(`Date : ${dateStr}`, rx, y0 + 14, { align: 'right' });
        if (refShort) doc.text(`Reference # : ${refShort}`, rx, y0 + 28, { align: 'right' });

        if (data.pageNumber === 1 && shippingLines.length) {
          let sy = y0 + 32;
          doc.setFont('helvetica', 'bold');
          doc.text('Ship To :', margin.left, sy);
          sy += 14;
          doc.setFont('helvetica', 'normal');
          shippingLines.forEach(line => {
            doc.text(line, margin.left + 8, sy);
            sy += 12;
          });
        }
      },

      didParseCell: (data) => {
        try {
          if (data.section !== 'body') return;
          const colKey = String(data.column.dataKey);
          const isMain = !!((data.row.raw || {}).__isMain);

          const c0 = data.row.cells && data.row.cells['0'];
          const c0txt = c0 ? (Array.isArray(c0.text) ? c0.text.join(' ') : String(c0.text || '')) : '';
          const isTotalRow = /^Estimated\s*total/i.test((c0txt || '').trim());

          if (!isMain && !isTotalRow && (colKey === '5' || colKey === '6')) {
            if (data.cell.styles) data.cell.styles.lineWidth = 0;
          }
        } catch (_) { }
      },

      didDrawCell: (data) => {
        try {
          if (data.section !== 'body') return;
          const colKey = String(data.column.dataKey);
          const isMain = !!((data.row.raw || {}).__isMain);

          if (isMain && colKey === '1') {
            currentLineNo = (data.row.raw.__lineNo || 0);
          }
          if (currentLineNo) {
            const bottom = data.cell.y + data.cell.height;
            if (!lineBottom[currentLineNo] || bottom > lineBottom[currentLineNo]) {
              lineBottom[currentLineNo] = bottom;
            }
          }

          if (colKey === '1' && !isMain && currentLineNo) {
            const txt = (Array.isArray(data.cell.text) ? data.cell.text.join(' ') : String(data.cell.text || '')).trim();
            if (/^·\s*Door\s*Size/i.test(txt)) {
              doorAnchor[currentLineNo] = { page: data.pageNumber, y: data.cell.y };
            }
            return;
          }

          if (isMain && (colKey === '5' || colKey === '6')) {
            const ln = data.row.raw.__lineNo;
            if (!rightBlock[ln]) {
              const rb = getRightBlockXYW(data);
              if (rb) {
                rightBlock[ln] = rb;
                pendingMain.push({ lineNo: ln });
                lastRBPerPage[data.pageNumber] = rb;
              }
            }
          }

          const c0 = data.row.cells && data.row.cells['0'];
          const c0txt = c0 ? (Array.isArray(c0.text) ? c0.text.join(' ') : String(c0.text || '')) : '';
          const isTotalRow = /^Estimated\s*total/i.test((c0txt || '').trim());

          if (!isMain && !isTotalRow && (colKey === '5' || colKey === '6')) {
            const x = data.cell.x, y = data.cell.y, w = data.cell.width, h = data.cell.height;
            const g = 200;
            data.doc.setDrawColor(g, g, g);
            data.doc.setLineWidth(0.6);
            data.doc.line(x, y, x, y + h);
            data.doc.line(x + w, y, x + w, y + h);
            return;
          }

          if (isTotalRow && (colKey === '5' || colKey === '6')) {
            const x = data.cell.x, y = data.cell.y, w = data.cell.width, h = data.cell.height;
            const g = 180;
            data.doc.setDrawColor(g, g, g);
            data.doc.setLineWidth(0.6);
            data.doc.rect(x, y, w, h);
            return;
          }
        } catch (_) { }
      },

      theme: 'grid',
      pageBreak: 'auto',
      tableWidth: contentW
    });

    const size = (im) => {
      const land = !!im.isLandscape;
      let w = (land ? BASE_LAND_W : BASE_PORT_W);
      let h = (land ? BASE_LAND_H : BASE_PORT_H);
      if (isTransomUrl(im.url)) {
        w += TRANSOM_W_BONUS;
        h += TRANSOM_H_BONUS;
      }
      const pb = panelBonus(im.url);
      w += pb.w; h += pb.h;
      return { w: w * IMG_SCALE, h: h * IMG_SCALE };
    };

    for (const m of pendingMain) {
      const ln = m.lineNo;
      const rawImgs = preImageMap[ln] || [];

      let rb = rightBlock[ln];
      if (!rb) {
        const hintPage = (doorAnchor[ln]?.page) || (rightBlock[ln]?.page) || 1;
        rb = lastRBPerPage[hintPage] || null;
      }
      if (!rawImgs.length || !rb) continue;

      const imgs = reorderImages(rawImgs).slice(0, MAX_IMAGES_PER_ITEM);

      const anchor = doorAnchor[ln];
      let page = (anchor && anchor.page) ? anchor.page : (rb.page || 1);
      doc.setPage(page);

      const areaX = rb.x;
      const areaW = Math.max(20, rb.w - RCOL_SHRINK_W);

      let y = ((anchor && anchor.y) ? anchor.y : rb.y) + RCOL_PAD + ANCHOR_EXTRA_Y;
      y = Math.max(y, (rb.y || 0) + RCOL_TOP_GUARD);

      const pageH = doc.internal.pageSize.getHeight();
      const pageBottom = pageH - margin.bottom;

      let needH = 0;
      for (let i = 0; i < imgs.length; i++) {
        const s = size(imgs[i]);
        needH += s.h;
        if (i < imgs.length - 1) needH += RCOL_GAP_Y;
      }
      needH += RCOL_PAD * 2;

      const lineBottomLimit =
        (lineBottom[ln] && page === rb.page)
          ? Math.min(lineBottom[ln], pageBottom)
          : pageBottom;
      const usableBottom = lineBottomLimit - RCOL_PAD;

      if (y + needH > usableBottom) {
        page = Math.min(page + 1, doc.getNumberOfPages());
        doc.setPage(page);
        y = margin.top + RCOL_TOP_GUARD;
      }

      for (let i = 0; i < imgs.length; i++) {
        const im = imgs[i];
        const s = size(im);
        const x = areaX + Math.max(0, (areaW - s.w) / 2);
        const extraDown = isTransomUrl(im.url) ? TRANSOM_EXTRA_DOWN : 0;
        try {
          doc.addImage(im.dataUrl, 'PNG', x, y + extraDown, s.w, s.h, undefined, 'FAST');
        } catch (_) { }
        const bottom = y + extraDown + s.h;
        if (!imgBottomByPage[page] || bottom > imgBottomByPage[page]) {
          imgBottomByPage[page] = bottom;
        }
        y += s.h + RCOL_GAP_Y;
      }
    }

    // Special Instruction + Disclaimer：最後一頁底部
    {
      let lastPage = doc.getNumberOfPages();
      doc.setPage(lastPage);
      const pageH = doc.internal.pageSize.getHeight();

      const baseAutoY = (doc.lastAutoTable && doc.lastAutoTable.finalY)
        ? doc.lastAutoTable.finalY + 18
        : (margin.top + 18);
      const imgBottom = imgBottomByPage[lastPage] ? imgBottomByPage[lastPage] + 16 : 0;
      let y = Math.max(baseAutoY, imgBottom || 0);
      y += 8;

      // 預留多一點空間給 Special Instruction + disclaimer
      if (y > pageH - margin.bottom - 60) {
        doc.addPage();
        lastPage = doc.getNumberOfPages();
        doc.setPage(lastPage);
        y = margin.top;
      }

      const maxW = pageW - margin.left - margin.right;

      if (specialRaw) {
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(10);
        doc.text('Special Instruction :', margin.left, y);
        doc.setFont('helvetica', 'normal');

        const lines = doc.splitTextToSize(specialRaw, maxW);
        const lineHeight = 12;
        doc.text(lines, margin.left, y + 14);
        y += 14 + lines.length * lineHeight + 8;
      }

      // disclaimer 行
      doc.setFont('helvetica', 'italic');
      doc.setFontSize(8.5);
      const dLines = doc.splitTextToSize(DISCLAIMER_TEXT, maxW);
      doc.text(dLines, margin.left, y);
    }

    // ★ 檔名：使用正式編號或 DRAFT-日期
    const fileNameBase = fileQuoteNo;
    const fileName = fileNameBase + '.pdf';

    const ab = await doc.output('arraybuffer');
const pdfBlob = new Blob([ab], { type: 'application/pdf' });
const subpath = `${ROOT_FOLDER}/${customerEmail}/${fmtMDY()}`;

if (window.ND_UPLOAD_EMAIL_BRIDGE) {
  window.ND_UPLOAD_EMAIL_BRIDGE.push({
    serial: fileName.replace(/\.pdf$/i, ''),
    customerEmail,
    customerName: '',
    subpath,
    pdfBlob,
    pdfName: fileName
  });
} else {
  try {
    await uploadToCloud(pdfBlob, fileName, subpath, {
      serial: fileName.replace(/\.pdf$/i, ''),
      reference: refShort
    });
  } catch (e) {
    console.warn('[ND-PDF] upload failed:', e?.message || e);
  }
}

doc.save(fileName);
  }

  async function onClick(ev) {
    const b = ev.currentTarget;
    try { b.disabled = true; } catch (_) { }
    try { await exportPDF(); }
    catch (e) {
      console.error('[PDF export]', e);
      alert('PDF 產生失敗：' + (e?.message || e));
    } finally {
      try { b.disabled = false; } catch (_) { }
    }
  }

  const ids = [
    'cx2-download-cart-pdf',
    'cx2-open-cart-html',
    'cx2-download-pdf',
    'download-cart-pdf'
  ];
  function bind() {
    for (const id of ids) {
      const el = document.getElementById(id);
      if (el) {
        const c = el.cloneNode(true);
        el.parentNode.replaceChild(c, el);
        c.addEventListener('click', onClick);
      }
    }
  }
  document.addEventListener('DOMContentLoaded', bind);
  setTimeout(bind, 400);
})();
